import { useEffect, useState } from "react";
import { useDispatch, useSelector} from "react-redux";
import { fetchFoods } from "../features/food/foodSlice";
import {  increaseQty, decreaseQty } from "../features/cart/cartSlice";
import { Link } from "react-router-dom";


function FoodList() {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const [sort, setSort] = useState(""); 
  const { items, status } = useSelector((state) => state.food);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // filter
  const filteredItems = items
  .filter((item) =>
    item.name.toLowerCase().includes(debouncedSearch.toLowerCase())
  )
  .filter((item) =>
    category === "all" ? true : item.mealType?.includes(category)
  )
  .sort((a, b) => {
    if (sort === "low") return a.price - b.price;
    if (sort === "high") return b.price - a.price;
    return 0;
  });

  const getQuantity = (id) => {
  const item = cartItems.find((i) => i.id === id);
  return item ? item.quantity : 0;
};

  // debouncing 
  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(search);
  }, 400);

  return () => clearTimeout(timer);
}, [search]);

  useEffect(() => {
    dispatch(fetchFoods());
  }, [dispatch]);

  if (status === "loading") return <h2>Loading...</h2>;
  if (status === "failed") return <h2>Error loading data</h2>;

  return (
    <>
    <div className="container-fluid home-container-banner d-flex align-items-center justify-content-center ">
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-6 mb-3 mt-4">
            <h3>Please check Menu</h3>
          </div>
        </div>

          <div className="row mb-4">
            {/* SEARCH */}
            <div className="col-md-4 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search food..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {/* SORT */}
            <div className="col-md-3 mb-2">
              <select
                className="form-select"
                value={sort}
                onChange={(e) => setSort(e.target.value)}
              >
                <option value="">Sort</option>
                <option value="low">Price: Low to High</option>
                <option value="high">Price: High to Low</option>
              </select>
            </div>

            {/* CATEGORY CHIPS */}
            <div className="col-md-5 d-flex gap-2 flex-wrap">
              {["all", "Breakfast", "Lunch", "Dinner"].map((cat) => (
                <button
                  key={cat}
                  className={`btn ${category === cat ? "btn-dark" : "btn-outline-dark"}`}
                  onClick={() => setCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
          <div className="row">
            {filteredItems.map((item) => (
              <div className="col-md-3 col-sm-6 mb-4" key={item.id}>
                <Link to={`/food/${item.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                  <div className="card border-0 shadow-sm h-100">
                    <img
                      src={item.image}
                      alt="food"
                      className="card-img-top"
                      style={{ height: "180px", objectFit: "cover" }}
                    />

                    <div className="card-body">
                      <h6 className="fw-bold">{item.name}</h6>
                      <p className="text-muted mb-2">{item.tags}</p>

                      <p className="text-muted mb-2">₹ {item.caloriesPerServing} </p>
                      <p className="text-muted mb-2">{item.rating}</p>
                      {getQuantity(item.id) === 0 ? (
                        <button
                          className="btn btn-dark w-100"
                          onClick={() => dispatch(increaseQty(item))}
                        >
                          Add to Cart
                        </button>
                      ) : (
                        <div className="d-flex justify-content-between align-items-center">
                          <button onClick={() => dispatch(decreaseQty(item.id))}>-</button>
                          <span>{getQuantity(item.id)}</span>
                          <button onClick={() => dispatch(increaseQty(item.id))}>+</button>
                        </div>
                      )}
                    </div>

                  </div>
                </Link>
              </div>
            ))}
        </div>
      </div>
    </div>

    
        <Link to="/cart">Go to Cart</Link>
        
        <h3>Cart Items: {cartItems.length}</h3>
      <h2>Food List</h2>
      
    </>
  );
}

export default FoodList;